var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","height":"15","viewBox":"0 0 16 15","width":"16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M14.9021 0L6.70422 8.99484L1.59785 5.83692L0 7.27557L6.87795 14.0124L15.84 0.749175L14.9021 0Z","fill":"#194BFB","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }